import { createSharedRoot } from '@bz/request';
import { useCurrency } from '@bz/common';
import Decimal from 'decimal.js-light';

export const useBetCreditOn = createSharedRoot(function () {
  const [isTopBetCreditOn, setTopBetCreditOn] = createSignal(false);
  const [isHotBetCreditOn, setHotBetCreditOn] = createSignal(false);
  const { latestCurrency, isCash, walletCreditInfo } = useCurrency();
  const computeBalance = (isCreditOn: boolean) => {
    const key = latestCurrency();
    if (isCash()) {
      const balance = currencyRecommend.currencyMap?.[key]?.balance ?? 0;
      if (isCreditOn) {
        const vipCreditBalance = walletCreditInfo()?.availableBalance || 0;
        const currencyBalance = currency.convertCurrency(new Decimal(vipCreditBalance), 'USDT', latestCurrency());
        const totalBalance = new Decimal(currencyBalance).add(new Decimal(balance))?.toNumber();
        return totalBalance;
      }
      return balance;
    }
    return currencyRecommend.bonus?.currencyList?.find((item) => item.currencyCode === key)?.balance ?? 0;
  };
  /* Top Events 根据是否开启信用额度计算余额，单位为当前货币latestCurrency的余额 */
  const topVipBalance = createMemo(() => {
    return computeBalance(isTopBetCreditOn());
  });
  /* Hot Combos 根据是否开启信用额度计算余额，单位为当前货币latestCurrency的余额 */
  const hotVipBalance = createMemo(() => {
    return computeBalance(isHotBetCreditOn());
  });
  return {
    topVipBalance,
    isTopBetCreditOn,
    setTopBetCreditOn,
    hotVipBalance,
    isHotBetCreditOn,
    setHotBetCreditOn,
  };
});

export const useResponsibleBetDepositLimit = createSharedRoot(function () {
  const insuranceStatus = useResource<ApiResponse<'getUserInsuranceGetInsuranceStatus'>>(
    async (pre) => {
      return account.isLogin ? await get.getUserInsuranceGetInsuranceStatus() : pre;
    },
    { initialValue: { placeBet: true, topUp: true } as ApiResponse<'getUserInsuranceGetInsuranceStatus'> }
  );
  const canPlaceBet = createMemo(() => {
    const status = insuranceStatus();
    if (!status) return true;
    return insuranceStatus()?.placeBet;
  });
  const canDeposit = createMemo(() => {
    const status = insuranceStatus();
    if (!status) return true;
    return insuranceStatus()?.topUp;
  });
  return {
    insuranceStatus,
    canPlaceBet,
    canDeposit,
  };
});
